import "./Playground.css";
import axios from "axios";
import { useState } from "react";

import { Layout } from "./components/layout/Layout.jsx";
import { useSettingsStore } from "./store/settings-store.js";
import { Home } from "./components/home/Home.jsx";
import { SelectDocument } from "./components/select-document/SelectDocument.jsx";
import { useSessionStore } from "../../../../store/session-store.js";
import { useAlertStore } from "../../../../store/alert-store.js";
import { LLM_WHISPERER_ENDPOINT } from "../../helper.js";

function Playground() {
  const { formData, fileData, isSubmitted, updateSettingsState, activeKey } =
    useSettingsStore();
  const { sessionDetails } = useSessionStore();
  const { setAlertDetails } = useAlertStore();
  const [uploadedDoc, setUploadedDoc] = useState(null);

  const beforeUpload = (file) => {
    // Convert the PDF file to Blob
    const reader = new FileReader();
    reader.onload = () => {
      const arrayBuffer = reader.result;
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });
      updateSettingsState({ fileUrl: URL.createObjectURL(blob) });
    };
    reader.readAsArrayBuffer(file);

    // Update file state
    updateSettingsState({ fileData: file, extractedText: "" });
    setUploadedDoc(file);

    return false;
  };

  const onSubmit = (mode, fileBlob, options) => {
    // Create a new FormData object
    const formDataToSend = new FormData();

    // Append each field and its value to the FormData object
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });
    if (mode && typeof mode === "string") {
      formDataToSend.delete("processing_mode"); // Ensure no duplicates
      formDataToSend.append("processing_mode", mode); // Add the new value
    }
    // Append the file to the FormData object
    formDataToSend.append("file", fileBlob || fileData);
    formDataToSend.append("unstract_key", activeKey); // Replace with your actual API key
    if (options) {
      formDataToSend.append("mark_vertical_lines", options?.verticalLine);
      formDataToSend.append("mark_horizontal_lines", options?.horizontalLine);
    }

    const requestOptions = {
      method: "POST",
      url: `${LLM_WHISPERER_ENDPOINT}/extract-text/`,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-CSRFToken": sessionDetails?.csrfToken,
      },
      data: formDataToSend,
    };

    let extractedText = "";
    updateSettingsState({ isLoading: true, extractedText, isSubmitted: true });
    axios(requestOptions)
      .then((res) => {
        extractedText = res?.data || "";
      })
      .catch((err) => {
        const error = err?.response?.data?.error;
        const message = error || "Failed to extract";
        setAlertDetails({
          type: "error",
          content: message,
        });
      })
      .finally(() => {
        updateSettingsState({
          isLoading: false,
          extractedText,
        });
      });
  };

  return (
    <Layout beforeUpload={beforeUpload} onSubmit={onSubmit}>
      {isSubmitted && activeKey ? (
        <Home beforeUpload={beforeUpload} onSubmit={onSubmit} />
      ) : (
        <SelectDocument
          beforeUpload={beforeUpload}
          onSubmit={onSubmit}
          uploadedDoc={uploadedDoc}
          setUploadedDoc={setUploadedDoc}
        />
      )}
    </Layout>
  );
}

export { Playground };
